import { ACCENT } from './constants';
import { ProfessionIcon } from './profession-icon';

export const IconMaid = () => (
  <ProfessionIcon>
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <path
        d="M3 22l1-7h16l1 7H3z"
        stroke={ACCENT}
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M8 15V9a4 4 0 018 0v6"
        stroke={ACCENT}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <circle cx="12" cy="5" r="2" stroke={ACCENT} strokeWidth="1.8" />
      <path
        d="M6 15l-2-4"
        stroke={ACCENT}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M18 15l2-4"
        stroke={ACCENT}
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  </ProfessionIcon>
);
